import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_10 = { style: {"padding":"8px"} }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.rapidtables.com/convert/number/decimal-to-hex.html",
  target: "_blank"
}, "Chuyển đổi số sang CharGUID", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sync_outlined = _resolveComponent("sync-outlined")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_ServerSelectView = _resolveComponent("ServerSelectView")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_user_switch_outlined = _resolveComponent("user-switch-outlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_audit_outlined = _resolveComponent("audit-outlined")!
  const _component_logout_outlined = _resolveComponent("logout-outlined")!
  const _component_thunderbolt_outlined = _resolveComponent("thunderbolt-outlined")!
  const _component_clear_outlined = _resolveComponent("clear-outlined")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_DownOutlined = _resolveComponent("DownOutlined")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_lock_outlined = _resolveComponent("lock-outlined")!
  const _component_KeyOutlined = _resolveComponent("KeyOutlined")!
  const _component_SearchOutlined = _resolveComponent("SearchOutlined")!
  const _component_environment_outlined = _resolveComponent("environment-outlined")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: _ctx.$t('screenTitle.userListManager')
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_alert, {
        "show-icon": "",
        class: "mb-20"
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_sync_outlined, { spin: _ctx.fetchingOnlineCount }, null, 8, ["spin"])
        ]),
        message: _withCtx(() => [
          _createTextVNode("Tổng số tài khoản đang online là: " + _toDisplayString(_ctx.number_format(_ctx.onlineCount)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_collapse, { class: "mb-20" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_collapse_panel, { header: "Tìm tài khoản bằng ID nhân vật trong game" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                ref: "formType",
                model: _ctx.formModel,
                onFinish: _ctx.onFinish,
                scrollToFirstError: true,
                layout: "vertical"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: _ctx.$t('labelText.server_name'),
                    name: "server_id",
                    rules: {required: true, trigger: ['change', 'blur']}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ServerSelectView, {
                        modelValue: _ctx.formModel.server_id,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formModel.server_id) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_a_form_item, {
                    label: _ctx.$t('labelText.char_guid'),
                    name: "charguid",
                    required: "",
                    rules: [{len: 8}, {pattern: /^[0-9a-fA-F]+$/}]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.formModel.charguid,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formModel.charguid) = $event)),
                        placeholder: "3C3ABCDE"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_space, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            "html-type": "submit",
                            loading: _ctx.isLoading
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('text.search')), 1)
                            ]),
                            _: 1
                          }, 8, ["loading"]),
                          _createVNode(_component_a_tooltip, { title: "Chuyển sang tài khoản khác" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                type: "primary",
                                onClick: _cache[2] || (_cache[2] = () => {
                                    _ctx.isShowChangeCharAccname = true;
                                    _ctx.selectingChar = {
                                        server_id: _ctx.formModel.server_id,
                                        accname: '',
                                        charguid_hex: _ctx.formModel.charguid,
                                        charguid: parseInt(_ctx.formModel.charguid, 16),
                                    };
                                })
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_user_switch_outlined)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "onFinish"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_collapse_panel, { header: "Thống kê tổng tài sản trong game" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                label: _ctx.$t('labelText.server_name'),
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ServerSelectView, {
                    modelValue: _ctx.statisticsServerId,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.statisticsServerId) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    disabled: !_ctx.statisticsServerId,
                    loading: _ctx.isFetchingStatistics,
                    onClick: _cache[4] || (_cache[4] = () => _ctx.onStatistics(_ctx.statisticsServerId))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('text.reload')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_card, { loading: _ctx.isFetchingStatistics }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, "Tổng số nhân vật: " + _toDisplayString(_ctx.number_format(_ctx.statistics.char_total)), 1),
                  _hoisted_1,
                  _createElementVNode("div", null, "Tổng số KNB trong char: " + _toDisplayString(_ctx.number_format(_ctx.statistics.yuanbao_total_char)), 1),
                  (_ctx.statistics.yuanbao_total_iteminfo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Tổng số KNB trong Item: " + _toDisplayString(_ctx.number_format(_ctx.statistics.yuanbao_total_iteminfo)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.statistics.yuanbao_total_pshop)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Tổng số KNB trong TH: " + _toDisplayString(_ctx.number_format(_ctx.statistics.yuanbao_total_pshop)), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, "Tổng số KNB: " + _toDisplayString(_ctx.number_format(_ctx.statistics.yuanbao_total)), 1),
                  _hoisted_4,
                  _createElementVNode("div", null, "Tổng số Điểm Tặng trong char: " + _toDisplayString(_ctx.number_format(_ctx.statistics.zengdian_total_char)), 1),
                  (_ctx.statistics.zengdian_total_iteminfo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Tổng số Điểm Tặng trong item: " + _toDisplayString(_ctx.number_format(_ctx.statistics.zengdian_total_iteminfo)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.statistics.zengdian_total_pshop)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Tổng số Điểm Tặng trong TH: " + _toDisplayString(_ctx.number_format(_ctx.statistics.zengdian_total_pshop)), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, "Tổng số Điểm Tặng: " + _toDisplayString(_ctx.number_format(_ctx.statistics.zengdian_total)), 1),
                  _hoisted_7,
                  _createElementVNode("div", null, "Tổng số Vàng trên người: " + _toDisplayString(_ctx.number_format(Math.floor(_ctx.statistics.vmoney_total / 100 / 100))), 1),
                  _createElementVNode("div", null, "Tổng số Vàng Khoá trên người: " + _toDisplayString(_ctx.number_format(Math.floor(_ctx.statistics.moneyjz_total / 100 / 100))), 1),
                  _hoisted_8,
                  (_ctx.statistics.iteminfo_same_guid && _ctx.statistics.iteminfo_same_guid.length)
                    ? (_openBlock(), _createBlock(_component_a_table, {
                        key: 4,
                        columns: Object.keys(_ctx.statistics.iteminfo_same_guid[0]).map(v => ({title: v, dataIndex: v})),
                        "data-source": _ctx.statistics.iteminfo_same_guid,
                        scroll: {x: '100%'}
                      }, {
                        title: _withCtx(() => [
                          _createTextVNode("Danh sách item trùng GUID item")
                        ]),
                        _: 1
                      }, 8, ["columns", "data-source"]))
                    : _createCommentVNode("", true),
                  (_ctx.statistics.pshop_same_guid && _ctx.statistics.pshop_same_guid.length)
                    ? (_openBlock(), _createBlock(_component_a_table, {
                        key: 5,
                        columns: Object.keys(_ctx.statistics.pshop_same_guid[0]).map(v => ({title: v, dataIndex: v})),
                        "data-source": _ctx.statistics.pshop_same_guid,
                        scroll: {x: '100%'}
                      }, {
                        title: _withCtx(() => [
                          _createTextVNode("Danh sách item trùng GUID TH")
                        ]),
                        _: 1
                      }, 8, ["columns", "data-source"]))
                    : _createCommentVNode("", true),
                  _hoisted_9,
                  _createElementVNode("div", null, "Check lúc: " + _toDisplayString((new Date())), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_collapse_panel, { header: "Danh sách nhân vật có tên tài khoản không hợp lệ (block/hack)" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                model: _ctx.formModelInvalidChars,
                onFinish: _ctx.onSubmitGetInvalidChars,
                layout: "inline"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: _ctx.$t('labelText.server_name'),
                    name: "server_id",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ServerSelectView, {
                        modelValue: _ctx.formModelInvalidChars.server_id,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formModelInvalidChars.server_id) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        "html-type": "submit",
                        loading: _ctx.isLoadingInvalidChars,
                        disabled: !_ctx.formModelInvalidChars.server_id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('text.search')), 1)
                        ]),
                        _: 1
                      }, 8, ["loading", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "onFinish"]),
              _createVNode(_component_a_table, {
                dataSource: _ctx.invalidChars,
                columns: _ctx.columnsInvalidChars,
                loading: _ctx.isLoadingInvalidChars
              }, {
                bodyCell: _withCtx(({ column, record: char_record }) => [
                  (column.key === 'action')
                    ? (_openBlock(), _createBlock(_component_a_space, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tooltip, { title: "Chuyển sang tài khoản khác" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                type: "primary",
                                onClick: () => {_ctx.isShowChangeCharAccname = true; _ctx.selectingChar = char_record;}
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_user_switch_outlined)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["dataSource", "columns", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_table, {
        dataSource: _ctx.dataSource,
        columns: _ctx.columns,
        pagination: _ctx.pagination,
        onChange: _ctx.onChange,
        loading: _ctx.isLoading,
        expandedRowKeys: _ctx.expandedRowKeys,
        "onUpdate:expandedRowKeys": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.expandedRowKeys) = $event)),
        "row-key": record => record.id,
        scroll: {x: '100%'}
      }, {
        bodyCell: _withCtx(({ column, record, text }) => [
          (column.key === 'action')
            ? (_openBlock(), _createBlock(_component_a_space, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tooltip, { title: "Thông tin nhân vật trong game" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: ($event: any) => (_ctx.showCharInGame(record))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_audit_outlined)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_a_tooltip, { title: "Reset trạng thái [Đang đăng nhập]" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: ($event: any) => (_ctx.resetLoggedIn(record)),
                        disabled: !record.pc_online
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_logout_outlined)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "disabled"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_a_tooltip, { title: "Kick khỏi game" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        danger: "",
                        onClick: () => { _ctx.isShowKickAssModal = true; _ctx.selectingKickAss = record; },
                        disabled: !record.pc_online
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_thunderbolt_outlined)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "disabled"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_a_tooltip, { title: "Xoá thông tin" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        danger: "",
                        onClick: ($event: any) => (_ctx.deleteConfirm(record))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_clear_outlined)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            : (column.dataIndex === 'role')
              ? (_openBlock(), _createBlock(_component_a_dropdown, { key: 1 }, {
                  overlay: _withCtx(() => [
                    _createVNode(_component_a_menu, {
                      onClick: (e) => _ctx.changeRole(record)(e)
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.UserRole).filter((v) => (isNaN(Number(v)) && (_ctx.UserRole[v as keyof typeof UserRole] !== _ctx.UserRole.GOD))), (roleK) => {
                          return (_openBlock(), _createBlock(_component_a_menu_item, {
                            key: _ctx.UserRole[roleK as keyof typeof UserRole],
                            disabled: _ctx.UserRole[roleK as keyof typeof UserRole] === text
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(_ctx.userRoleText(_ctx.UserRole[roleK as keyof typeof UserRole])), 1)
                            ]),
                            _: 2
                          }, 1032, ["disabled"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_tag, {
                      color: _ctx.userRoleColor(text)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.userRoleText(text)) + " ", 1),
                        _createVNode(_component_DownOutlined)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  _: 2
                }, 1024))
              : (column.dataIndex === 'is_lock')
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 2,
                    type: text ? 'primary' : 'ghost',
                    onClick: ($event: any) => (_ctx.switchLock(record))
                  }, {
                    icon: _withCtx(() => [
                      (!text)
                        ? (_openBlock(), _createBlock(_component_lock_outlined, { key: 0 }))
                        : (_openBlock(), _createBlock(_component_KeyOutlined, { key: 1 }))
                    ]),
                    _: 2
                  }, 1032, ["type", "onClick"]))
                : _createCommentVNode("", true)
        ]),
        customFilterDropdown: _withCtx(({ setSelectedKeys, selectedKeys, confirm, clearFilters, column }) => [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_a_input, {
              ref: "searchInput",
              placeholder: `Search ${column.dataIndex}`,
              value: selectedKeys,
              style: {"width":"188px","margin-bottom":"8px","display":"block"},
              onChange: (e) => setSelectedKeys(e.target.value),
              onPressEnter: ($event: any) => (_ctx.handleSearch(selectedKeys, confirm, column.dataIndex))
            }, null, 8, ["placeholder", "value", "onChange", "onPressEnter"]),
            _createVNode(_component_a_button, {
              type: "primary",
              size: "small",
              style: {"width":"calc(60% - 8px)","margin-right":"8px"},
              onClick: ($event: any) => (_ctx.handleSearch(selectedKeys, confirm, column.dataIndex))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_SearchOutlined)
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('text.search')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_a_button, {
              size: "small",
              style: {"width":"40%"},
              onClick: ($event: any) => (_ctx.handleReset(clearFilters))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Reset")
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        expandedRowRender: _withCtx(({ record }) => [
          _createVNode(_component_a_collapse, { class: "mb-20" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_collapse_panel, { header: "Xem toàn bộ thông tin ẩn" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('labelText.user_email')) + ": " + _toDisplayString(record.email || _ctx.$t('text.notUpdated')), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('labelText.user_tel')) + ": " + _toDisplayString(record.tel || _ctx.$t('text.notUpdated')), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('labelText.user_question')) + ": " + _toDisplayString(record.question || _ctx.$t('text.notUpdated')), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('labelText.user_answer')) + ": " + _toDisplayString(record.answer || _ctx.$t('text.notUpdated')), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('labelText.user_coin')) + ": " + _toDisplayString(_ctx.number_format(record.coin)), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('labelText.user_promotion_coin')) + ": " + _toDisplayString(_ctx.number_format(record.promotion_coin)), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('labelText.user_point')) + ": " + _toDisplayString(_ctx.number_format(record.point)), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_a_form, {
            ref: "formType",
            onSubmit: () => _ctx.onSubmitGetChars(record),
            layout: "inline"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                label: _ctx.$t('labelText.server_name')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ServerSelectView, {
                    modelValue: record.server_id,
                    "onUpdate:modelValue": ($event: any) => ((record.server_id) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1032, ["label"]),
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    "html-type": "submit",
                    loading: record.isLoadingChars,
                    disabled: !record.server_id
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('text.search')), 1)
                    ]),
                    _: 2
                  }, 1032, ["loading", "disabled"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["onSubmit"]),
          _createVNode(_component_a_table, {
            dataSource: record.chars,
            columns: _ctx.columnsChars,
            loading: record.isLoadingChars
          }, {
            bodyCell: _withCtx(({ column, record: char_record }) => [
              (column.key === 'action')
                ? (_openBlock(), _createBlock(_component_a_space, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_tooltip, { title: "Chuyển sang tài khoản khác" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            onClick: () => {_ctx.isShowChangeCharAccname = true; _ctx.selectingChar = char_record;}
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_user_switch_outlined)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_a_tooltip, { title: "Fix kẹt map" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            disabled: "",
                            onClick: ($event: any) => (_ctx.fixMapStuck(char_record))
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_environment_outlined)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["dataSource", "columns", "loading"])
        ]),
        _: 1
      }, 8, ["dataSource", "columns", "pagination", "onChange", "loading", "expandedRowKeys", "row-key"]),
      _createVNode(_component_a_modal, {
        open: _ctx.isShowKickAssModal,
        "onUpdate:open": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isShowKickAssModal) = $event)),
        footer: null,
        title: "Kick người chơi khỏi game"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            layout: "vertical",
            model: _ctx.selectingKickAss,
            onFinish: _ctx.kickFromGame
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                label: _ctx.$t('labelText.user_name'),
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.selectingKickAss.name,
                    disabled: ""
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_a_form_item, {
                name: "id",
                required: "",
                hidden: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.selectingKickAss.id,
                    disabled: ""
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: _ctx.$t('labelText.server_name'),
                name: "server_id",
                rules: {required: true, trigger: ['change', 'blur']}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ServerSelectView, {
                    modelValue: _ctx.selectingKickAss.server_id,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectingKickAss.server_id) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    "html-type": "submit",
                    loading: _ctx.isKickingAss
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Kick")
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "onFinish"])
        ]),
        _: 1
      }, 8, ["open"]),
      _createVNode(_component_a_modal, {
        open: _ctx.isShowChangeCharAccname,
        "onUpdate:open": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.isShowChangeCharAccname) = $event)),
        footer: null,
        title: "Chuyển nhân vật sang tài khoản khác"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            layout: "vertical",
            model: _ctx.selectingChar,
            onSubmit: _cache[10] || (_cache[10] = () => _ctx.changeCharAccname(_ctx.selectingChar))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                label: "Nhân vật",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: `${_ctx.selectingChar.charname_utf8} (${_ctx.selectingChar.level}) - ${_ctx.selectingChar.charguid_hex}`,
                    readonly: ""
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: _ctx.$t('labelText.user_name'),
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.selectingChar.accname,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectingChar.accname) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    "html-type": "submit",
                    disabled: !_ctx.selectingChar.accname || !_ctx.selectingChar.accname.length || !_ctx.selectingChar.server_id || !_ctx.selectingChar.charguid,
                    loading: _ctx.selectingChar.isChangingAccname
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Chuyển")
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]),
          _hoisted_11,
          _createVNode(_component_a_list, {
            "item-layout": "vertical",
            pagination: _ctx.paginationChangeCharAccnameHistory,
            "data-source": _ctx.dataSourceChangeCharAccnameHistory
          }, {
            renderItem: _withCtx(({ item }) => [
              _createVNode(_component_a_list_item, { key: "item.id" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.value), 1),
                  _hoisted_12,
                  _createTextVNode(_toDisplayString(item.created_at), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["pagination", "data-source"])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }, 8, ["title"]))
}